(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4071],{

/***/ 97183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84321);
/* harmony import */ var _Sider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7293);


const Layout = _layout__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP;
Layout.Header = _layout__WEBPACK_IMPORTED_MODULE_0__/* .Header */ .h4;
Layout.Footer = _layout__WEBPACK_IMPORTED_MODULE_0__/* .Footer */ .$_;
Layout.Content = _layout__WEBPACK_IMPORTED_MODULE_0__/* .Content */ .VY;
Layout.Sider = _Sider__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["Z"] = (Layout);

/***/ }),

/***/ 41196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15746);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61235);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);






var ContactUs = function(param) {
    var title = param.title, description = param.description;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timer = setInterval(function() {
            var ref;
            if (!(window === null || window === void 0 ? void 0 : window.hbspt) || !"22338452" || !"99744054-3948-4b74-bc53-82a9382be05d") return;
            window === null || window === void 0 ? void 0 : (ref = window.hbspt) === null || ref === void 0 ? void 0 : ref.forms.create({
                region: "na1",
                portalId: "22338452",
                formId: "99744054-3948-4b74-bc53-82a9382be05d",
                target: "#contact"
            });
            clearInterval(timer);
        }, 1000);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container bg-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                span: 24,
                xs: 24,
                sm: 24,
                md: 20,
                lg: 16,
                xl: 14,
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("font-bolder-xl lh-md mb-20 mt-40", (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title)),
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().description), "font-regular-base  lh-sm ms-10"),
                        dangerouslySetInnerHTML: {
                            __html: description || ""
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "contact",
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mb-30"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                            type: "text/javascript",
                            src: "//js.hsforms.net/forms/embed/v2.js"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactUs);


/***/ }),

/***/ 64071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ HelpCenter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/shared/HelpCenter/styles.module.scss
var styles_module = __webpack_require__(81205);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/components/shared/Fields/index.tsx + 1 modules
var Fields = __webpack_require__(62574);
// EXTERNAL MODULE: ./src/components/shared/Icon/index.tsx
var Icon = __webpack_require__(81394);
// EXTERNAL MODULE: ./public/assets/icons/search.svg
var search = __webpack_require__(73437);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js + 1 modules
var divider = __webpack_require__(96074);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 25 modules
var tabs = __webpack_require__(26981);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/components/shared/Accordion/index.tsx
var Accordion = __webpack_require__(82147);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/shared/ContactUs/index.tsx
var ContactUs = __webpack_require__(41196);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/shared/Button/index.tsx
var Button = __webpack_require__(5172);
// EXTERNAL MODULE: ./src/components/shared/HelpCenter/HelpCenterPage/styles.module.scss
var HelpCenterPage_styles_module = __webpack_require__(87936);
var HelpCenterPage_styles_module_default = /*#__PURE__*/__webpack_require__.n(HelpCenterPage_styles_module);
// EXTERNAL MODULE: ./node_modules/antd/es/layout/index.js
var layout = __webpack_require__(97183);
// EXTERNAL MODULE: ./node_modules/antd/es/menu/index.js + 11 modules
var menu = __webpack_require__(68508);
// EXTERNAL MODULE: ./src/libs/context/index.js
var context = __webpack_require__(58218);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/libs/resources/index.js + 1 modules
var resources = __webpack_require__(41090);
;// CONCATENATED MODULE: ./src/components/shared/HelpCenter/HelpCenterPage/index.tsx












var Content = layout/* default.Content */.Z.Content, Sider = layout/* default.Sider */.Z.Sider;
var HelpCenterPage = function(param) {
    var setIsHelpCenterPage = param.setIsHelpCenterPage, vendor = param.vendor, buyer = param.buyer, category = param.category;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var router = (0,next_router.useRouter)();
    var initValues = (ref1 = (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[1]) === null || ref2 === void 0 ? void 0 : ref2.split("-");
    var ref15 = (0,react.useContext)(context/* AppContext */.I), helpCenterQuery = ref15.helpCenterQuery, setHelpCenterQuery = ref15.setHelpCenterQuery;
    var ref16 = (0,react.useState)(), buyerMenu = ref16[0], setBuyerMenu = ref16[1];
    var ref17 = (0,react.useState)(), vendorMenu = ref17[0], setVendorMenu = ref17[1];
    var ref18 = (0,react.useState)(false), open = ref18[0], setOpen = ref18[1];
    var ref19 = (0,react.useState)(helpCenterQuery), current = ref19[0], setCurrent = ref19[1];
    var ref20 = (0,react.useState)(category ? category : (initValues === null || initValues === void 0 ? void 0 : initValues[(initValues === null || initValues === void 0 ? void 0 : initValues.length) - 1]) ? initValues === null || initValues === void 0 ? void 0 : initValues[(initValues === null || initValues === void 0 ? void 0 : initValues.length) - 1] : ""), currentCategory = ref20[0], setCurrentCategory = ref20[1];
    var ref21 = (0,react.useState)(), content = ref21[0], setContent = ref21[1];
    var ref22 = (0,react.useState)(), accordionItems = ref22[0], setAccordionItems = ref22[1];
    var ref23 = (0,react.useState)(""), searchText = ref23[0], setSearchText = ref23[1];
    var handelSearchTextChange = function(e) {
        var target = e.target;
        setSearchText(target === null || target === void 0 ? void 0 : target.value);
    };
    var filteredFQA = function() {
        var faq = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var filteredItems;
        filteredItems = faq === null || faq === void 0 ? void 0 : faq.filter(function(item) {
            var ref, ref1;
            return (ref1 = item === null || item === void 0 ? void 0 : (ref = item.header) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLocaleLowerCase());
        });
        console.log("Filtered FAQ items:", filteredItems);
        return filteredItems;
    };
    (0,react.useEffect)(function() {
        var ref;
        var buyerData = [];
        var vendorData = [];
        buyer === null || buyer === void 0 ? void 0 : buyer.map(function(item) {
            var ref;
            return buyerData === null || buyerData === void 0 ? void 0 : buyerData.push({
                label: item === null || item === void 0 ? void 0 : item.name,
                key: "".concat(item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.slice(1), "-buyer"),
                faqs: item === null || item === void 0 ? void 0 : item.faqs
            });
        });
        vendor === null || vendor === void 0 ? void 0 : vendor.map(function(item) {
            var ref;
            return vendorData === null || vendorData === void 0 ? void 0 : vendorData.push({
                label: item === null || item === void 0 ? void 0 : item.name,
                key: "".concat(item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.slice(1), "-vendor"),
                faqs: item === null || item === void 0 ? void 0 : item.faqs
            });
        });
        var currentVal = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[1];
        if (currentVal === null || currentVal === void 0 ? void 0 : currentVal.includes("buyer")) {
            var buyerArr = buyerData === null || buyerData === void 0 ? void 0 : buyerData.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.key) === currentVal;
            });
            setAccordionItems(filteredFQA((buyerArr === null || buyerArr === void 0 ? void 0 : buyerArr.faqs) || []));
            setContent(buyerArr === null || buyerArr === void 0 ? void 0 : buyerArr.label);
        } else if (currentVal === null || currentVal === void 0 ? void 0 : currentVal.includes("vendor")) {
            var vendorArr = vendorData === null || vendorData === void 0 ? void 0 : vendorData.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.key) === currentVal;
            });
            setAccordionItems(filteredFQA((vendorArr === null || vendorArr === void 0 ? void 0 : vendorArr.faqs) || []));
            setContent(vendorArr === null || vendorArr === void 0 ? void 0 : vendorArr.label);
        }
        setBuyerMenu(buyerData);
        setVendorMenu(vendorData);
        console.log("Buyer Data:", buyerData);
        console.log("Vendor Data:", vendorData);
    }, [
        searchText,
        buyer,
        vendor
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var currentVal = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[1];
        if ((currentVal === null || currentVal === void 0 ? void 0 : currentVal.includes("buyer")) && buyerMenu) {
            var buyerArr = buyerMenu === null || buyerMenu === void 0 ? void 0 : buyerMenu.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.key) === currentVal;
            });
            setAccordionItems(filteredFQA((buyerArr === null || buyerArr === void 0 ? void 0 : buyerArr.faqs) || []));
            setContent(buyerArr === null || buyerArr === void 0 ? void 0 : buyerArr.label);
        } else if ((currentVal === null || currentVal === void 0 ? void 0 : currentVal.includes("vendor")) && vendorMenu) {
            var vendorArr = vendorMenu === null || vendorMenu === void 0 ? void 0 : vendorMenu.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.key) === currentVal;
            });
            setAccordionItems(filteredFQA((vendorArr === null || vendorArr === void 0 ? void 0 : vendorArr.faqs) || []));
            setContent(vendorArr === null || vendorArr === void 0 ? void 0 : vendorArr.label);
        }
        console.log("Current Value:", currentVal);
        console.log("Buyer Menu:", buyerMenu);
        console.log("Vendor Menu:", vendorMenu);
    }, [
        router,
        buyerMenu,
        vendorMenu
    ]);
    var closeView = function() {
        setIsHelpCenterPage(false);
        router.push("/help-center");
    };
    (0,react.useEffect)(function() {
        var ref, ref1;
        var userType = (ref1 = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")) === null || ref1 === void 0 ? void 0 : ref1[1];
        var isBuyer = userType === null || userType === void 0 ? void 0 : userType.includes("buyer");
        var isVendor = userType === null || userType === void 0 ? void 0 : userType.includes("vendor");
        isBuyer ? onBuyerClick({
            key: userType
        }) : isVendor ? onVendorClick({
            key: userType
        }) : null;
    }, [
        (ref4 = router === null || router === void 0 ? void 0 : (ref3 = router.asPath) === null || ref3 === void 0 ? void 0 : ref3.split("?")) === null || ref4 === void 0 ? void 0 : ref4[1]
    ]);
    var onBuyerClick = function(info) {
        var arr = buyerMenu === null || buyerMenu === void 0 ? void 0 : buyerMenu.find(function(item) {
            return (item === null || item === void 0 ? void 0 : item.key) === (info === null || info === void 0 ? void 0 : info.key);
        });
        setAccordionItems(filteredFQA((arr === null || arr === void 0 ? void 0 : arr.faqs) || []));
        setContent(arr === null || arr === void 0 ? void 0 : arr.label);
        setCurrent(info === null || info === void 0 ? void 0 : info.key);
        setHelpCenterQuery(info.key);
        setCurrentCategory("Buyer");
        setOpen(false);
        router.push("/help-center?".concat(info.key));
        console.log("Buyer Click:", arr);
    };
    var onVendorClick = function(info) {
        var arr = vendorMenu === null || vendorMenu === void 0 ? void 0 : vendorMenu.find(function(item) {
            return (item === null || item === void 0 ? void 0 : item.key) === (info === null || info === void 0 ? void 0 : info.key);
        });
        setAccordionItems(filteredFQA((arr === null || arr === void 0 ? void 0 : arr.faqs) || []));
        setContent(arr === null || arr === void 0 ? void 0 : arr.label);
        setOpen(false);
        setCurrentCategory("Vendor");
        setHelpCenterQuery(info.key);
        setCurrent(info.key);
        router.push("/help-center?".concat(info.key));
        console.log("Vendor Click:", arr);
    };
    var AccordionDetails = function(param) {
        var content = param.content;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "font-medium-base pt-6 ".concat((HelpCenterPage_styles_module_default()).AccordionContainer),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: content
                }
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((HelpCenterPage_styles_module_default()).helpCenter__wrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
            className: "".concat((HelpCenterPage_styles_module_default()).helpCenter__container, " container bg-transparent text-oxfordBlue"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Sider, {
                    className: "".concat((HelpCenterPage_styles_module_default()).helpCenter__sidebar, " py-34"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "font-bold-h4",
                                    children: (ref5 = (0,resources/* getText */.Q)()) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.HelpCenter) === null || ref6 === void 0 ? void 0 : ref6.buyerTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default */.Z, {
                                    className: "".concat((HelpCenterPage_styles_module_default()).helpCenter__menu, " bg-transparent font-medium-base"),
                                    items: buyerMenu,
                                    onClick: onBuyerClick,
                                    selectedKeys: [
                                        current
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "font-bold-h4 pt-18",
                                    children: (ref7 = (0,resources/* getText */.Q)()) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.HelpCenter) === null || ref8 === void 0 ? void 0 : ref8.vendorTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default */.Z, {
                                    className: "".concat((HelpCenterPage_styles_module_default()).helpCenter__menu, " bg-transparent font-medium-base"),
                                    items: vendorMenu,
                                    onClick: onVendorClick,
                                    selectedKeys: [
                                        current
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    className: "".concat((HelpCenterPage_styles_module_default()).helpCenter__content, " bg-white ps-8 py-30 text-oxfordBlue"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((HelpCenterPage_styles_module_default()).mobileBtn),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return setOpen(true);
                                },
                                className: "".concat((HelpCenterPage_styles_module_default()).menuBtn, " bg-oxfordBlue"),
                                children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "cross",
                                    width: 18,
                                    height: 18,
                                    color: "#ffffff",
                                    dir: "bottom"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "menu",
                                    width: 18,
                                    height: 18,
                                    color: "#ffffff"
                                })
                            })
                        }),
                        open && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((HelpCenterPage_styles_module_default()).mobileSidebar, "  pt-20 bg-white"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((HelpCenterPage_styles_module_default()).menuWrapper),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((HelpCenterPage_styles_module_default()).header, " px-8"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "font-bold-h4",
                                                    children: (ref9 = (0,resources/* getText */.Q)()) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.HelpCenter) === null || ref10 === void 0 ? void 0 : ref10.buyerTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: function() {
                                                        return setOpen(false);
                                                    },
                                                    className: "".concat((HelpCenterPage_styles_module_default()).menuBtn, " bg-oxfordBlue"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        name: "cross",
                                                        width: 18,
                                                        height: 18,
                                                        color: "#ffffff"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default */.Z, {
                                            className: "".concat((HelpCenterPage_styles_module_default()).helpCenter__menu, " bg-transparent font-medium-base"),
                                            items: buyerMenu,
                                            onClick: onBuyerClick,
                                            selectedKeys: [
                                                current
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((HelpCenterPage_styles_module_default()).menuWrapper),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "font-bold-h4 pt-8 ps-8",
                                            children: (ref11 = (0,resources/* getText */.Q)()) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.HelpCenter) === null || ref12 === void 0 ? void 0 : ref12.vendorTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default */.Z, {
                                            className: "".concat((HelpCenterPage_styles_module_default()).helpCenter__menu, " bg-transparent font-medium-base"),
                                            items: vendorMenu,
                                            onClick: onVendorClick,
                                            selectedKeys: [
                                                current
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            className: "".concat((HelpCenterPage_styles_module_default()).helpCenterBtn, " ps-0 font-bold-h6 bg-transparent text-oxfordBlue mb-12"),
                            onClick: closeView,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "arrow",
                                    dir: "bottom"
                                }),
                                (ref13 = (0,resources/* getText */.Q)()) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.HelpCenter) === null || ref14 === void 0 ? void 0 : ref14.backToHelpCenter
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                            justify: "space-between",
                            gutter: [
                                16,
                                16
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    className: "font-bold-lg",
                                    style: {
                                        textTransform: "capitalize"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            currentCategory,
                                            " - ",
                                            content
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields/* default */.Z, {
                                        type: "search",
                                        className: (HelpCenterPage_styles_module_default()).searchField,
                                        onChange: function(e) {
                                            return handelSearchTextChange(e);
                                        },
                                        onIconClick: function(e) {
                                            return handelSearchTextChange(e);
                                        },
                                        onPressEnter: function(e) {
                                            return handelSearchTextChange(e);
                                        },
                                        placeholder: "Search",
                                        hasIcon: true,
                                        Icon: search/* default */.Z,
                                        allowClear: {
                                            clearIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                name: "mobileCross",
                                                classesName: "d-flex py-5"
                                            })
                                        },
                                        value: searchText,
                                        prefix: true
                                    })
                                })
                            ]
                        }),
                        accordionItems === null || accordionItems === void 0 ? void 0 : accordionItems.map(function(item, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                className: "".concat((HelpCenterPage_styles_module_default()).accordionItem, " py-8"),
                                header: item === null || item === void 0 ? void 0 : item.header,
                                closedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "down",
                                    width: 24,
                                    height: 24,
                                    dir: "",
                                    color: "#02254a"
                                }),
                                openedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "down",
                                    width: 24,
                                    height: 24,
                                    dir: "top",
                                    color: "#02254a"
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails, {
                                    content: item === null || item === void 0 ? void 0 : item.content
                                })
                            }, index);
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var HelpCenter_HelpCenterPage = (HelpCenterPage);

;// CONCATENATED MODULE: ./src/components/shared/HelpCenter/index.tsx

















var HelpCenter = function(param) {
    var bannertitle = param.bannertitle, bannerImage = param.bannerImage, buyer = param.buyer, vendor = param.vendor, bannerTitleColor = param.bannerTitleColor, thanksMessage = param.thanksMessage, linkText = param.linkText, linkValue = param.linkValue, thanksImage = param.thanksImage, faqs = param.faqs;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    console.log("HelpCenter Props:", {
        bannertitle: bannertitle,
        bannerImage: bannerImage,
        buyer: buyer,
        vendor: vendor,
        bannerTitleColor: bannerTitleColor,
        thanksMessage: thanksMessage,
        linkText: linkText,
        linkValue: linkValue,
        thanksImage: thanksImage,
        faqs: faqs
    }); // Debug log
    var router = (0,next_router.useRouter)();
    var setHelpCenterQuery = (0,react.useContext)(context/* AppContext */.I).setHelpCenterQuery;
    var ref14 = (0,react.useState)(false), isHelpCenterPage = ref14[0], setIsHelpCenterPage = ref14[1];
    var bannerStyle = {
        backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), url(".concat(bannerImage === null || bannerImage === void 0 ? void 0 : bannerImage.url, ")")
    };
    var ref15 = (0,react.useState)(""), inputValue = ref15[0], setInputValue = ref15[1];
    var ref16 = (0,react.useState)(), item = ref16[0], setCurrentItem = ref16[1];
    var ref17 = (0,react.useState)(), category = ref17[0], setCategory = ref17[1];
    var ref18 = (0,react.useState)(false), isFormSent = ref18[0], setIsFormSentHelpCenter = ref18[1];
    var ref19 = (0,react.useState)(false), isSearchOpen = ref19[0], setisSearchOpen = ref19[1];
    var ref20 = (0,react.useState)(faqs), filteredFaqs = ref20[0], setFilteredFaqs = ref20[1];
    var ref21 = (0,react.useState)(), filteredBuyers = ref21[0], setFilteredBuyers = ref21[1];
    var ref22 = (0,react.useState)(), filteredVendors = ref22[0], setFilteredVendors = ref22[1];
    (0,react.useEffect)(function() {
        console.log("Initial State:", {
            inputValue: inputValue,
            item: item,
            category: category,
            isFormSent: isFormSent,
            isSearchOpen: isSearchOpen,
            filteredFaqs: filteredFaqs,
            filteredBuyers: filteredBuyers,
            filteredVendors: filteredVendors
        });
    }, []);
    var filterValues = function(values, type, searchValue) {
        var arr = [];
        arr = values === null || values === void 0 ? void 0 : values.filter(function(item) {
            var ref, ref1;
            return (ref1 = item === null || item === void 0 ? void 0 : (ref = item.header) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes(searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLocaleLowerCase());
        });
        if (type === "buyer") arr = arr === null || arr === void 0 ? void 0 : arr.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.bussnissType) === "buyer";
        });
        if (type === "vendor") arr = arr === null || arr === void 0 ? void 0 : arr.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.bussnissType) === "vendor";
        });
        console.log("Filtered ".concat(type, " values:"), arr);
        return arr;
    };
    var handelInputChange = function(e) {
        var ref;
        setisSearchOpen(true);
        var inputSearchValue = e === null || e === void 0 ? void 0 : (ref = e.currentTarget) === null || ref === void 0 ? void 0 : ref.value;
        setInputValue(inputSearchValue);
        console.log("Input Change:", inputSearchValue);
        if (!inputSearchValue) {
            setFilteredFaqs(faqs);
            setFilteredBuyers(faqs === null || faqs === void 0 ? void 0 : faqs.filter(function(item) {
                return (item === null || item === void 0 ? void 0 : item.bussnissType) === "buyer";
            }));
            setFilteredVendors(faqs === null || faqs === void 0 ? void 0 : faqs.filter(function(item) {
                return (item === null || item === void 0 ? void 0 : item.bussnissType) === "vendor";
            }));
        } else {
            setFilteredFaqs(filterValues(faqs, "all", inputSearchValue));
            setFilteredBuyers(filterValues(faqs, "buyer", inputSearchValue));
            setFilteredVendors(filterValues(faqs, "vendor", inputSearchValue));
        }
        console.log("Filtered Data:", {
            filteredFaqs: filteredFaqs,
            filteredBuyers: filteredBuyers,
            filteredVendors: filteredVendors
        });
    };
    var backToHelp = function() {
        setisSearchOpen(false);
        setInputValue("");
        console.log("Back to Help Center");
    };
    var DetailsPanel = function(param) {
        var content = param.content;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: content
        });
    };
    var FaqsSelected = function(param) {
        var dataSource = param.dataSource;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(function(item, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                    className: "".concat((styles_module_default()).faqsPanel, " mb-8 py-4"),
                    header: item === null || item === void 0 ? void 0 : item.header,
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsPanel, {
                        content: item === null || item === void 0 ? void 0 : item.content
                    }),
                    closedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "down",
                        width: 24,
                        height: 24,
                        dir: "",
                        color: "#02254a"
                    }),
                    openedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "down",
                        width: 24,
                        height: 24,
                        dir: "top",
                        color: "#02254a"
                    })
                }, index);
            })
        });
    };
    var items = [
        {
            label: "All",
            key: "1",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqsSelected, {
                dataSource: filteredFaqs
            })
        },
        {
            label: "Buyer",
            key: "2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqsSelected, {
                dataSource: filteredBuyers || []
            })
        },
        {
            label: "Vendor",
            key: "3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqsSelected, {
                dataSource: filteredVendors || []
            })
        }, 
    ];
    var navigationHandler = function(label, item, link) {
        setHelpCenterQuery(link.slice(1));
        setCategory(label);
        setCurrentItem(item);
        // Push new URL and set `isHelpCenterPage` to true
        router.push("/help-center".concat(link), undefined, {
            shallow: true
        });
        setIsHelpCenterPage(true);
        console.log("Navigation Handler:", {
            label: label,
            item: item,
            link: link
        });
    };
    (0,react.useEffect)(function() {
        var query = new URLSearchParams(window.location.search);
        var queryKey = query.keys().next().value;
        var queryValue = query.get(queryKey);
        console.log("Router Query Change:", {
            queryKey: queryKey,
            queryValue: queryValue
        });
        // Set `isHelpCenterPage` to true only if the query matches the expected format
        if (queryKey && (queryKey.includes("buyer") || queryKey.includes("vendor"))) {
            setIsHelpCenterPage(true);
        } else {
            setIsHelpCenterPage(false);
        }
        // Handle browser back button
        var handlePopState = function() {
            if (!window.location.search) {
                setIsHelpCenterPage(false);
            }
        };
        window.addEventListener("popstate", handlePopState);
        return function() {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [
        router === null || router === void 0 ? void 0 : router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: !isHelpCenterPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container py-20",
            children: !isFormSent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((styles_module_default()).banneContainer),
                        style: bannerStyle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((styles_module_default()).searchWrapper, " mx-6"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: classnames_default()((styles_module_default()).bannerTextWrapper, "font-bolder-xl lh-md  mb-8"),
                                    style: {
                                        color: "".concat(bannerTitleColor)
                                    },
                                    dangerouslySetInnerHTML: {
                                        __html: bannertitle
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields/* default */.Z, {
                                    type: "search",
                                    onChange: function(e) {
                                        return handelInputChange(e);
                                    },
                                    onIconClick: function(e) {
                                        return handelInputChange(e);
                                    },
                                    onPressEnter: function(e) {
                                        return handelInputChange(e);
                                    },
                                    placeholder: "Search",
                                    "aria-label": "Search",
                                    hasIcon: true,
                                    Icon: search/* default */.Z,
                                    allowClear: {
                                        clearIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            name: "mobileCross",
                                            classesName: "py-5 d-flex"
                                        })
                                    },
                                    className: (styles_module_default()).searchField,
                                    value: inputValue,
                                    prefix: true
                                })
                            ]
                        })
                    }),
                    isSearchOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((styles_module_default()).searchResultContainer, "mt-16"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                theme: "primary",
                                className: classnames_default()((styles_module_default()).backIconWrapper, "text-oxfordBlue bg-white $oxford-blue font-regular-h6 mb-10"),
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "arrow",
                                    dir: "top"
                                }),
                                onClick: backToHelp,
                                children: (ref = (0,resources/* getText */.Q)()) === null || ref === void 0 ? void 0 : (ref1 = ref.HelpCenter) === null || ref1 === void 0 ? void 0 : ref1.backToHelpCenter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-bold-lg lh-lg text-oxfordBlue",
                                children: (ref2 = (0,resources/* getText */.Q)()) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.HelpCenter) === null || ref3 === void 0 ? void 0 : ref3.searchResults
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "font-regular-base",
                                children: [
                                    filteredFaqs === null || filteredFaqs === void 0 ? void 0 : filteredFaqs.length,
                                    " ",
                                    (ref4 = (0,resources/* getText */.Q)()) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.HelpCenter) === null || ref5 === void 0 ? void 0 : ref5.resultsFor,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "font-bold-base ps-1",
                                        children: [
                                            " “",
                                            inputValue,
                                            "”"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {
                                type: "horizontal",
                                className: (styles_module_default()).divider
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* default */.Z, {
                                defaultActiveKey: "1",
                                items: items,
                                tabBarStyle: {
                                    border: "none"
                                }
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                className: classnames_default()((styles_module_default()).linksSectionContainer, "my-20"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        span: 24,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            theme: "primary",
                                            className: classnames_default()((styles_module_default()).backIconWrapper, "bg-white  mb-10"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold-lg text-oxfordBlue ms-6 mb-4",
                                                children: (ref6 = (0,resources/* getText */.Q)()) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.HelpCenter) === null || ref7 === void 0 ? void 0 : ref7.buyerTitle
                                            })
                                        })
                                    }),
                                    buyer && (buyer === null || buyer === void 0 ? void 0 : buyer.map(function(item) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            span: 8,
                                            xs: 12,
                                            sm: 12,
                                            md: 8,
                                            lg: 8,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/help-center/".concat(item === null || item === void 0 ? void 0 : item.link, "-buyer"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: function() {
                                                        return navigationHandler("Buyer", item === null || item === void 0 ? void 0 : item.name, "".concat(item === null || item === void 0 ? void 0 : item.link, "-buyer"));
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classnames_default()((styles_module_default()).linkBoxContainer, "font-bold-h3 text-oxfordBlue"),
                                                        children: item === null || item === void 0 ? void 0 : item.name
                                                    })
                                                })
                                            })
                                        }, item === null || item === void 0 ? void 0 : item.name);
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                className: classnames_default()((styles_module_default()).linksSectionContainer, "my-20"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        span: 24,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            theme: "primary",
                                            className: classnames_default()((styles_module_default()).backIconWrapper, "bg-white  mb-10"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold-lg text-oxfordBlue ms-6 mb-4",
                                                children: (ref8 = (0,resources/* getText */.Q)()) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.HelpCenter) === null || ref9 === void 0 ? void 0 : ref9.vendorTitle
                                            })
                                        })
                                    }),
                                    vendor && (vendor === null || vendor === void 0 ? void 0 : vendor.map(function(item) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            span: 24,
                                            xs: 12,
                                            sm: 12,
                                            md: 8,
                                            lg: 8,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/help-center".concat(item === null || item === void 0 ? void 0 : item.link, "-vendor"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: function() {
                                                        return navigationHandler("Vendor", item === null || item === void 0 ? void 0 : item.name, "".concat(item === null || item === void 0 ? void 0 : item.link, "-vendor"));
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classnames_default()((styles_module_default()).linkBoxContainer, "py-10 font-bold-h3 text-oxfordBlue"),
                                                        children: item === null || item === void 0 ? void 0 : item.name
                                                    })
                                                })
                                            })
                                        }, item === null || item === void 0 ? void 0 : item.name);
                                    }))
                                ]
                            }),
                            faqs && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).questionsContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-bold-lg lh-lg text-oxfordBlue mb-10",
                                        children: (ref10 = (0,resources/* getText */.Q)()) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.HelpCenter) === null || ref11 === void 0 ? void 0 : ref11.FAQSTitle
                                    }),
                                    faqs === null || faqs === void 0 ? void 0 : faqs.map(function(item, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                            className: "".concat((styles_module_default()).faqsPanel, " mb-8 py-4"),
                                            header: item === null || item === void 0 ? void 0 : item.header,
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsPanel, {
                                                content: item === null || item === void 0 ? void 0 : item.content
                                            }),
                                            closedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                name: "down",
                                                width: 24,
                                                height: 24,
                                                dir: "",
                                                color: "#02254a"
                                            }),
                                            openedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                name: "down",
                                                width: 24,
                                                height: 24,
                                                dir: "top",
                                                color: "#02254a"
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((styles_module_default()).contactHeader, "font-bold-lg lh-lg text-oxfordBlue mb-10 mt-14"),
                                children: (ref12 = (0,resources/* getText */.Q)()) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.HelpCenter) === null || ref13 === void 0 ? void 0 : ref13.contactUsTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((styles_module_default()).contactUsContainer),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUs/* default */.Z, {
                                    setIsFormSentHelpCenter: setIsFormSentHelpCenter
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((styles_module_default()).thanksMessageContainer, "my-30"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("font-regular-h3 text-oxfordBlue mb-4", (styles_module_default()).message),
                        dangerouslySetInnerHTML: {
                            __html: thanksMessage || ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).imgWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            unoptimized: true,
                            src: (thanksImage === null || thanksImage === void 0 ? void 0 : thanksImage.url) || "",
                            alt: thanksImage === null || thanksImage === void 0 ? void 0 : thanksImage.altText,
                            layout: "fill",
                            objectFit: "contain"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: linkValue,
                        className: "text-primary font-regular-h6 mt-10",
                        children: linkText
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCenter_HelpCenterPage, {
            itemLabel: item,
            category: category,
            setCategory: setCategory,
            buyer: buyer,
            vendor: vendor,
            setIsHelpCenterPage: setIsHelpCenterPage
        })
    });
};


/***/ }),

/***/ 61235:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"description":"style_description__Kmpqh"};

/***/ }),

/***/ 87936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__366xm","AccordionContainer":"styles_AccordionContainer__O__CR","helpCenter__menu":"styles_helpCenter__menu__9GtUh","helpCenter__wrapper":"styles_helpCenter__wrapper__OoGF5","helpCenter__sidebar":"styles_helpCenter__sidebar__SW441","helpCenter__content":"styles_helpCenter__content__ddeBr","mobileBtn":"styles_mobileBtn__yxkFR","mobileSidebar":"styles_mobileSidebar__dMhQV","menuWrapper":"styles_menuWrapper__SLACA","header":"styles_header__rxixo","menuBtn":"styles_menuBtn__9cisa","helpCenterBtn":"styles_helpCenterBtn__bK2mM","accordionItem":"styles_accordionItem__KQvIo","searchField":"styles_searchField__03dXR"};

/***/ }),

/***/ 81205:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banneContainer":"styles_banneContainer__E_2p9","searchWrapper":"styles_searchWrapper__T_rzS","bannerTextWrapper":"styles_bannerTextWrapper__N0L_B","searchField":"styles_searchField__PYiPV","linksSectionContainer":"styles_linksSectionContainer__8eQTL","linkBoxContainer":"styles_linkBoxContainer__Z499h","questionsContainer":"styles_questionsContainer__pYe_z","contactHeader":"styles_contactHeader__6gcAJ","faqsPanel":"styles_faqsPanel__Lir_R","contactUsContainer":"styles_contactUsContainer__ixktX","thanksMessageContainer":"styles_thanksMessageContainer__YFY3x","message":"styles_message__h8vBp","imgWrapper":"styles_imgWrapper__5DX6C","sendBttnWrapper":"styles_sendBttnWrapper__ZUPjy","searchResultContainer":"styles_searchResultContainer__2tmw_","divider":"styles_divider__oR4ts","backIconWrapper":"styles_backIconWrapper__53vFo"};

/***/ })

}]);